/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleQueryName extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ScheduleQueryName");
    }

    getFixupPrototypeFunction() { return ScheduleQueryName.fixupPrototype; }

    static newInstance(model: Partial<ScheduleQueryName>): ScheduleQueryName {
        let obj = Object.assign(new ScheduleQueryName(), model);
        ScheduleQueryName.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleQueryName>): ScheduleQueryName {
        if (!model) return null;
        return ScheduleQueryName.newInstance(<ScheduleQueryName> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleQueryName) {
        if (!obj) return;

        models.ScheduleQueryName.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleQueryName): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleQueryName.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Regular expression to match against Schedule name
     */
    name: string;

}
